import styled from 'styled-components';
import { mediaQuery, toRem } from '../../styles/functions';

export const SelectContainer = styled.div`
  width: 100%;
  // margin: -10px 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const StyledSelect = styled.select`
  background: #FFF url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path fill='%23000' d='M1.5 4.5l4.5 4.5 4.5-4.5'/></svg>") no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  width: 100%; 
  padding: 10px 30px 10px 10px;
  border: none;
  border-radius: 4px;
  appearance: none;
  position: relative;
  font-size: 18px;
  color: #000;
  cursor: pointer;
`;

export const ExtraText = styled.span`
  color: #24A4C4;
  flex: 1; 
  text-align: right;
  padding-left: 10px;
  padding-right: 35px;
  position: absolute;
  font-weight: 400;
  font-size: 18px;
  right: 0;
  pointer-events: none;
//   ${mediaQuery('xxxs')(`	
//   font-size: ${toRem(12)};
// `)}
`;